import { API_BASE_URL } from "../config/apiConfig";

const fetchAPI = async (endpoint, method = "GET", body = null, token = null) => {
    const headers = {
        "Content-Type": "application/json",
    };

    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const options = {
        method,
        headers,
    };

    if (body) {
        options.body = JSON.stringify(body);
    }

    const response = await fetch(`${API_BASE_URL}/api/sub/${endpoint}`, options);
    return response.json();
};

export const getSubs = (token) => fetchAPI(" ", "GET", null, token);

export const getSubUser = (user_id, token) => fetchAPI(`single/${user_id}`, "GET", null, token);



export const updateSubscriptionStatus = (subscriptionId, updateData, token) =>
    fetchAPI(`/update/${subscriptionId}`, "PUT", updateData, token);

